import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "./useAuth";
import { ROLE } from "../constants/enums";
import { showError } from "../constants/toasts";
import { Permission } from "../services/accessRole";

interface Permissions {
  label: string;
  isAdd: boolean;
  isView: boolean;
  isDelete: boolean;
  isEdit: boolean;
}

type SidebarLabels =
  | "Dashboard"
  | "Manage Users"
  | "Rewards & Offers Management"
  | "Transactions & Loyalty Logs"
  | "Online Brands Management"
  | "Store Management"
  | "Feedback, Reports & Logs"
  | "System Settings"
  | "Notification Center"
  | "Activity Logs"
  | "Manage Sub-Admin"
  | "Manage CMS Pages";

type PagePermission = "isView" | "isAdd";

const usePermission = ({
  label,
  page_permission,
}: {
  label: SidebarLabels;
  page_permission: PagePermission;
}) => {
  const userData = useAuth() as any;
  const navigate = useNavigate();
  const [permission, setPermission] = useState<Permissions | null>();

  const checkPermission = () => {
    const permissions = userData?.accessRole?.permission as Permission[];
    const matchedPermission = permissions.find(
      (perm: Permissions) => perm.label === label
    );

    if (matchedPermission) {
      setPermission(matchedPermission);
    } else {
      navigate("/permission-denied", { replace: true });
    }
  };

  useEffect(() => {
    if (userData && userData?.role === ROLE.SUB_ADMIN) {
      checkPermission();
    } else {
      setPermission({
        label: "admin",
        isAdd: true,
        isView: true,
        isDelete: true,
        isEdit: true,
      });
    }
  }, [userData]);

  useEffect(() => {
    if (permission && !permission?.[page_permission]) {
      showError("Access denied");
      navigate("/permission-denied", { replace: true });
    }
  }, [permission]);

  return {
    isAdd: !!permission?.isAdd,
    isDelete: !!permission?.isDelete,
    isEdit: !!permission?.isEdit,
    isView: !!permission?.isView,
    // permission,
  };
};

export default usePermission;